import React from 'react';
import { Link } from "react-router-dom";
import styled from "styled-components";

const SGrammar = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const Grammar = () => {
  return (
    <SGrammar>
      <h5>Gramatyka</h5>
      <li><Link to="/grammar/introducion">Wprowadzenie (Introducion)</Link></li>
      <li><Link to="/grammar/alfabeto">Alfabet (Alfabeto)</Link></li>
      <li><Link to="/grammar/articulos">Rodzajniki (Artículos)</Link></li>
      <li><Link to="/grammar/adjetivos">Przymiotniki (Adjetivos)</Link></li>
      <li><Link to="/grammar/numerales">Liczebniki (Numerales)</Link></li>
      <li><Link to="/grammar/pronombres">Zaimki (Pronombres)</Link></li>
      <li><Link to="/grammar/adverbios">Przysłówki (Adverbios)</Link></li>
      <li><Link to="/grammar/preposiciones">Przyimki (Preposiciónes)</Link></li>
      <li><Link to="/grammar/indicativo">Tryb oznajmujący (Modo Indicativo)</Link></li>
      <li><Link to="/grammar/subjuntivo">Tryb łączący (Modo Subjuntivo)</Link></li>
      <li><Link to="/grammar/condicional">Tryb warunkowy (Modo Condicional)</Link></li>
      <li><Link to="/grammar/imperativo">Tryb rozkazujący (Modo Imperativo)</Link></li>
      <li><Link to="/grammar/perifrasis">Wyrażenia czasownikowe (Perífrasis verbales)</Link></li>
      <li><Link to="/grammar/serestarhaber"><i>Ser/Estar/Haber</i> (czasowniki wyrażające polski czasownik 'być')</Link></li>
      <li><Link to="/grammar/condicionales">Zdania warunkowe (Frases condicionales)</Link></li>
      <li><Link to="/grammar/indirecto">Mowa zależna (Estilo indirecto)</Link></li>
      <li><Link to="/grammar/pasiva">Strona bierna (La vos pasiva)</Link></li>
      <li><Link to="/grammar/temporales">Zdania czasowe (Frases temporales)</Link></li>
    </SGrammar>
  )
};

export default Grammar;